// 本地存取操作
// 按需导出保存方法
export const setItem = (key, value) => {
  //  如果提交的是一个对象或数组，需要转成json字符串
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  // 将字符传保存到本地
  window.localStorage.setItem(key, value)
}
//  按需导出读取方法
export const getItem = (key) => {
  //  从本地根据key，读取字符串
  const value = window.localStorage.getItem(key)
  // 把value转成JSON对象
  try {
  // 如果转换成功，说明数据是数组或对象，那就直接返回
    return JSON.parse(value)
  } catch (err) {
  // 如果转换失败，说明数据是值类型数据，直接返回
    return value
  }
}
